import AdManagementMediaReducer from 'store/ad-management-media/reducers';

export default AdManagementMediaReducer;
